/* eslint-disable default-param-last */
const initialState = {
  templateInfo: null,
};

const fileInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_DOCUMENTS_INFO":
      return { ...state, templateInfo: action.payload };
    default:
      return state;
  }
};

export default fileInfoReducer;
